"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Constants = void 0;
class Constants {
}
exports.Constants = Constants;
Constants.usoNuovaUCC = true;
Constants.networkConfigExpirationMillis = 1000 * 60 * 60 * 24;
Constants.currentCurrency = " € ";
Constants.retryInterval = 500;
Constants.dateUpdateProfileNeeded = 1579042800000; // 15/01/2020
Constants.dateLoyaltyProgramVisibility = 1593554340000; // 01/07/2020 00:00:00
Constants.renderHomepage = {
    item: "_data001",
    value: "true",
};
Constants.oldVersion = true;
Constants.superUserMessage = "Il Super Utente non può accedere a questa funzionalità dell'utente impersonificato";
Constants.superUserServiceLevel = "SUPER_USER";
Constants.serviceLevels = {
    WAIT_PG: "WAIT_PG",
    LIGHT: "LIGHT",
    SMART: "SMART",
    STRONG: "STRONG",
};
Constants.privacyLevels = {
    CG: "CG",
    MISSING_CONSENT: "CM",
    COMPANY_CONSENT: "CP",
    REVOKED: "REV",
    OPT_OUT: "OPT",
    PRIVACY_COMMERCIALE_MANCANTE_OLD: "00",
    PRIVACY_1_OLD: "01",
    PRIVACY_2_OLD: "02",
    PRIVACY_1_ACCEPTED: "03",
    PRIVACY_2_ACCEPTED: "04",
    PRIVACY_3_ACCEPTED: "05",
    PRIVACY_2_3_ACCEPTED: "06",
};
Constants.vendor = {
    comp: "I4982898H_DDD3313*èAùùRFFa3H5%&£",
    dist: "A73/Ki2rrfo/GNTi8AN+PaP",
    jar: "*_V^XcD,L$$)2,T`TpWLznk@.D:M6ZYk",
    var: "JTH74Iieh2=945dLp0?(jw921j4j53jk",
    calc: "V}Nc3$346w+SZ$KY&Cc7~uv%>a(%V{^M",
    merge: "7n?gS;vLDw$Q@[{7VUw87RFFa3[Apx%",
    size: "U78/Kiqdwaf425NTi8{AN+PaB2A3P",
    dust: ":V@E}>eL+HA:_Dz+k=Pr.8R]9nT]8tnw",
    core: "U78/Kiqdo/GNTi8{AN+PaB2A3P",
    link: "FKFUE83IR+RRRIUE54*P43(+HE",
};
Constants.laTuaAgenzia = {
    closed: "CHIUSO",
    closedAgency: "FILIALE CHIUSA",
    separator: " - ",
    separatorMattinaPomeriggio: " / ",
};
Constants.breakpoint = {
    mobile: 320,
    tablet: 768,
    desktop: 1280,
    desktop_xl: 1660,
};
Constants.policiesFamilyId = {
    mobilita: 1000,
    casa: 1001,
    protezione: 1002,
    risparmio: 1003,
    risparmioPrevidenza: [
        {
            ppiul: "117",
            ppipv: "118",
            fpa: "153",
        },
    ],
    lavoro: 1004,
    altro: 1005,
};
Constants.TYPE_PERSONA_COOKIE = "TypeUser";
Constants.typePersona = {
    personaFisica: "P",
    personaGiuridica: "O",
};
Constants.typePersonaSuperUser = {
    personaFisica: "F",
    personaGiuridica: "G",
};
Constants.typePolizzaRisparmioPrevidenza = {
    paymentProtectionInsurance: "PPI",
    openedPensionFunds: "FPA",
};
Constants.lsMap = [
    "_data0",
    "_data1",
    "_data2",
    "_data3",
    "_data4",
    "_data5",
    "_data6",
    "_data7",
    "_data8",
    "_data9",
    "_data10",
]; // Manteniamo per retrocompatibilità
Constants.lsMapObject = {
    _data0: "_data0",
    _data1: "_data1",
    _data2: "_data2",
    _data3: "_data3",
    _data4: "_data4",
    _data5: "_data5",
    _data5_1: "_data5_1",
    _data6: "_data6",
    _data7: "_data7",
    _data8: "_data8",
    _data9: "_data9",
    _data10: "_data10",
    _data11: "_data11",
    _data12: "_data12",
    _data13: "_data13",
    _data14: "_data14",
    _data15: "_data15",
    _data16: "_data16",
    _data17: "_data17",
    IVASS: "IVASS",
    agenziaAderenteLoyalty: "agenziaAderenteLoyalty",
    _sh: "_sh",
    afterPinRedirect: "afterPinRedirect",
    xPayData3dSecure: "x-pay-data-3d-secure",
    metodoPagamentoRicorrente: "metodoPagamentoRicorrente",
};
Constants.venditaIbridaConstants = {
    UINFO_PET: "UINFO_PET",
    UINFO_VIAGGI: "UINFO_VIAGGI",
    QUOTAZIONE_PET: "QUOTAZIONE_PET",
    QUOTAZIONE_VIAGGI: "QUOTAZIONE_VIAGGI",
    QUOTAZIONE_PEGA: "QUOTAZIONE_PEGA",
    FORM_UTENTE_VALUE: "FORM_UTENTE_VALUE",
};
Constants.publicLsMap = ["preventivatore_auto", "preventivatore_moto"];
Constants.quoteLsMap = [
    "preventivo_precedente_auto",
    "preventivo_precedente_moto",
];
Constants.quoteLsMapObject = {
    preventivo_precedente_auto: "preventivo_precedente_auto",
    preventivo_precedente_moto: "preventivo_precedente_moto",
};
Constants.ssMap = ["_s_data0"];
Constants.basicPrivateAreaUrl = "/area_riservata/";
Constants.homePagePrivateAreaUrlLocal = "/TpdPortalHomeWidget/TpdPortalHomeWidgetWeb/build";
Constants.accountPrivateAreaUrlLocal = "/TpdPortalAccountWidget/TpdPortalAccountWidgetWeb/build/";
Constants.telematicsPrivateAreaUrlLocal = "/TpdPortalTelematiciWidget/TpdPortalTelematiciWidgetWeb/build/";
Constants.polizzePrivateAreaUrlLocal = "/TpdPortalPolizzeWidget/TpdPortalPolizzeWidgetWeb/build/";
Constants.sinistriPrivateAreaUrlLocal = "/TpdPortalSinistriWidget/TpdPortalSinistriWidgetWeb/build/";
Constants.selfregPrivateAreaUrlLocal = "/TpdPortalSelfRegWidget/TpdPortalSelfRegWidgetWeb/build/";
Constants.pasAssistenzaPrivateAreaUrlLocal = "/TpdPortalPasAssistenzaWidget/TpdPortalPasAssistenzaWidgetWeb/build/";
Constants.loyaltyPrivateAreaUrlLocal = "/TpdPortalLoyaltyWidget/TpdPortalLoyaltyWidgetWeb/build/";
Constants.preventiviPrivateAreaUrlLocal = "/TpdPortalPreventiviWidget/TpdPortalPreventiviWidgetWeb/build/";
Constants.url /* : UrlsInterface[] */ = [
    {
        hub: Constants.accountPrivateAreaUrlLocal + "index.siti-integrati.html",
        homepage: Constants.homePagePrivateAreaUrlLocal,
        datipersonali: Constants.accountPrivateAreaUrlLocal + "index.dati-personali.html",
        gestioneutenzeaziendali: Constants.accountPrivateAreaUrlLocal +
            "index.gestione-utenze-aziendali.html",
        presentazioneagenzia: Constants.accountPrivateAreaUrlLocal +
            "index.presentazione-agenzia.html",
        casacommercio: Constants.telematicsPrivateAreaUrlLocal + "index.casa-commercio.html",
        unibox: Constants.telematicsPrivateAreaUrlLocal + "index.unibox.html",
        dettagliopolizza: Constants.polizzePrivateAreaUrlLocal + "index.dettaglio-polizza.html",
        dettagliopolizzaCollettiva: Constants.polizzePrivateAreaUrlLocal +
            "index.dettaglio-polizza-collettiva.html",
        dettaglioPolizzaPrevidenza: Constants.polizzePrivateAreaUrlLocal +
            "index.dettaglio-polizza-previdenza.html",
        dettaglioPolizzaRe: Constants.polizzePrivateAreaUrlLocal +
            "index.dettaglio-polizza-re.html",
        elencopolizze: Constants.polizzePrivateAreaUrlLocal + "index.elenco-polizze.html",
        trackingsinistri: Constants.sinistriPrivateAreaUrlLocal + "index.tracking-sinistri.html",
        parcheggi: "/TpdPortalMyParkingWidget/TpdPortalMyParkingWidgetWeb/build",
        login: Constants.selfregPrivateAreaUrlLocal + "index.login.html",
        registrazioneclienti: Constants.selfregPrivateAreaUrlLocal +
            "index.registrazione-clienti.html",
        superuser: Constants.selfregPrivateAreaUrlLocal + "index.super-user.html",
        preventivi: Constants.preventiviPrivateAreaUrlLocal +
            "index.elenco-preventivi.html",
        attestatorischioHome: Constants.polizzePrivateAreaUrlLocal +
            "index.elenco-polizze.html?risk=true",
        attestatoRischioAreaPubblica: "/attestato-di-rischio",
        attestatorischio: Constants.polizzePrivateAreaUrlLocal +
            "index.dettaglio-polizza.html?risk=true",
        possiamoaiutarti: "/servizio-clienti",
        soccorsoauto: "/soccorso-stradale",
        privacy: Constants.accountPrivateAreaUrlLocal + "index.privacy.html",
        denunciasinistri: Constants.sinistriPrivateAreaUrlLocal + "index.denuncia-sinistri.html",
        denuncianuovosinistro: Constants.sinistriPrivateAreaUrlLocal + "index.targhe.html",
        preaperturasinistro: Constants.sinistriPrivateAreaUrlLocal + "index.preapertura-steps.html",
        denunceinviate: Constants.sinistriPrivateAreaUrlLocal + "index.denunce-inviate.html",
        confermainviodenuncia: Constants.sinistriPrivateAreaUrlLocal + "index.conferma-invio.html",
        inserimentopin: Constants.accountPrivateAreaUrlLocal + "index.inserimento-pin.html",
        informativaprivacy: 
        //'/TpdPortalCommons/TpdPortalCommonsWeb/WebContent/assets/pdf/USA_Info_Hins_02.pdf',
        "/TpdPortalCommons/TpdPortalCommonsWeb/WebContent/assets/pdf/USA_Info_UteU_01.pdf",
        informativaprivacyUnipol: "/NextAssets/pdf/USA_Info_UteU_01.pdf",
        informativaprivacyArAp: "/wcm/myconnect/35158955-0c4f-47e2-852f-9582f44f4715/USA_Info_ArAp_01.pdf?MOD=AJPERES&CVID=oUUAq7y&useDefaultText=0&useDefaultDesc=0",
        informativaprivacyArApUnipol: "/wcm/myconnect/35158955-0c4f-47e2-852f-9582f44f4715/Informativa+Area+Riservata.pdf?MOD=AJPERES&CVID=pdjLvDZ&useDefaultText=0&useDefaultDesc=0",
        documentidettagliopolizza: Constants.polizzePrivateAreaUrlLocal +
            "index.dettaglio-polizza.html#documenti",
        informativaareariservata: "/informativa-area-riservata",
        riepilogodenuncia: Constants.sinistriPrivateAreaUrlLocal + "index.riepilogo-denuncia.html",
        fea: "/fea-firma-elettronica",
        dettaglio: Constants.pasAssistenzaPrivateAreaUrlLocal + "index.dettaglio.html",
        preventivatoreFQ: "/TpdPortalCommons/TpdPortalCommonsWeb/WebContent/preventivatore-auto.html",
        preventiviAuto: "/TpdPortalCommons/TpdPortalCommonsWeb/WebContent/preventivatore-auto.html",
        preventiviMoto: "/TpdPortalCommons/TpdPortalCommonsWeb/WebContent/preventivatore-auto.html",
        sceltaTarghePas: Constants.pasAssistenzaPrivateAreaUrlLocal + "index.scelta-targa.html",
        noTargheAssistenza: Constants.pasAssistenzaPrivateAreaUrlLocal + "index.no-garanzia.html",
        motivazione: Constants.pasAssistenzaPrivateAreaUrlLocal +
            "index.scelta-motivazione.html",
        questionario: Constants.pasAssistenzaPrivateAreaUrlLocal + "index.questionario.html",
        sanicard: Constants.polizzePrivateAreaUrlLocal + "index.dettaglio-polizza.html",
        popcoin: Constants.loyaltyPrivateAreaUrlLocal +
            "index.loyalty-diario-locale.html",
        informativaPopcoin: Constants.loyaltyPrivateAreaUrlLocal +
            "index.loyalty-iscrizione.html#informativaLocale",
        iscrizione: Constants.loyaltyPrivateAreaUrlLocal + "index.loyalty-iscrizione.html",
        iscrizioneEsito: Constants.loyaltyPrivateAreaUrlLocal +
            "index.loyalty-iscrizione.html#esito",
        elencoBuoni: Constants.loyaltyPrivateAreaUrlLocal +
            "index.loyalty-buono-elenco.html",
        elencoBuoniCancella: Constants.loyaltyPrivateAreaUrlLocal +
            "index.loyalty-esiti-locale.html#cancella",
        estrattoConto: Constants.loyaltyPrivateAreaUrlLocal +
            "index.loyalty-dettaglio-popcoin-locale.html",
        creaBuono: Constants.loyaltyPrivateAreaUrlLocal +
            "index.loyalty-crea-buono-locale.html",
        creaBuonoEsito: Constants.loyaltyPrivateAreaUrlLocal +
            "index.loyalty-esiti-locale.html",
        faqPopcoin: Constants.loyaltyPrivateAreaUrlLocal +
            "index.loyalty-diario-locale.html",
        privacypage: Constants.accountPrivateAreaUrlLocal + "index.privacy.html",
        servizioClienti: "/servizio-clienti/informazioni",
        riepilogoVisita: Constants.sinistriPrivateAreaUrlLocal + "index.riepilogo-visita.html",
        prenotazioneVisita: Constants.sinistriPrivateAreaUrlLocal +
            "index.prenotazione-visita.html",
        modificaVersioneControparte: Constants.sinistriPrivateAreaUrlLocal +
            "index.modifica-versione-controparte.html",
        negaVersioneControparte: Constants.sinistriPrivateAreaUrlLocal +
            "index.nega-versione-controparte.html",
        caricamentoDocumenti: Constants.preventiviPrivateAreaUrlLocal + "index.documentazione.html",
        spedizionePolizza: Constants.preventiviPrivateAreaUrlLocal +
            "index.spedizione-polizza.html",
        acquistoPolizza: Constants.preventiviPrivateAreaUrlLocal + "index.acquisto.html",
        esitoAcquisto: Constants.preventiviPrivateAreaUrlLocal + "index.esiti.html",
        esitoSpedizione: Constants.preventiviPrivateAreaUrlLocal + "index.esiti.html",
        sitointegratoagenzia: Constants.accountPrivateAreaUrlLocal +
            "index.presentazione-agenzia.html",
        aggiornamentoProfilo: Constants.accountPrivateAreaUrlLocal + "index.aggiorna-profilo.html",
        esitoAggiornamentoProfilo: Constants.accountPrivateAreaUrlLocal +
            "index.aggiorna-profilo-esiti.html",
        notificheAreaRiservata: Constants.homePagePrivateAreaUrlLocal +
            "index.notifiche-area-riservata.html",
        informativaRinnovoPolizza: Constants.polizzePrivateAreaUrlLocal + "index.rinnovo-polizza.html",
        pagamentoRinnovoPolizza: Constants.basicPrivateAreaUrl + "index.pagamento-rinnovo-polizza.html",
        esitoRinnovoPolizza: Constants.basicPrivateAreaUrl + "index.esito-rinnovo-polizza.html",
        telepedaggioLandingGuest: "index.telepedaggio-landing.html",
        telepedaggioLanding: Constants.basicPrivateAreaUrl + "index.telepedaggio-landing.html",
        telepedaggioAcquisto: Constants.basicPrivateAreaUrl + "index.telepedaggio-acquisto.html",
        serviziMobilita: Constants.basicPrivateAreaUrl + "index.servizi-mobilita.html",
        serviziMobilitaTelepedaggio: Constants.basicPrivateAreaUrl +
            "index.servizi-mobilita/telepedaggio.html",
        telepedaggioModificaOfferta: Constants.basicPrivateAreaUrl +
            "index.servizi-mobilita/telepedaggio/modifica-offerta.html",
    },
    {
        hub: Constants.basicPrivateAreaUrl + "seleziona-agenzia",
        homepage: Constants.basicPrivateAreaUrl + "home",
        datipersonali: Constants.basicPrivateAreaUrl + "dati-personali",
        gestioneutenzeaziendali: Constants.basicPrivateAreaUrl +
            "dati-personali" +
            "/gestione-utenze-aziendali",
        presentazioneagenzia: Constants.basicPrivateAreaUrl + "agenzia",
        casacommercio: Constants.basicPrivateAreaUrl + "telematica-immobili",
        unibox: Constants.basicPrivateAreaUrl + "telematica-mobilita",
        dettagliopolizza: Constants.basicPrivateAreaUrl + "polizze/polizza",
        dettagliopolizzaCollettiva: Constants.basicPrivateAreaUrl + "polizze/polizza-collettiva",
        dettaglioPolizzaPrevidenza: Constants.basicPrivateAreaUrl + "polizze/polizza-previdenza",
        dettaglioPolizzaRe: Constants.basicPrivateAreaUrl + "polizze/polizza-rami-elementari",
        elencopolizze: Constants.basicPrivateAreaUrl + "polizze",
        trackingsinistri: Constants.basicPrivateAreaUrl + "sinistri/tracking-sinistri",
        parcheggi: Constants.basicPrivateAreaUrl + "home",
        login: "/accesso",
        registrazioneclienti: "/registrazione-cliente",
        superuser: Constants.basicPrivateAreaUrl + "home-superuser",
        preventivi: Constants.basicPrivateAreaUrl + "preventivi",
        attestatorischioHome: Constants.basicPrivateAreaUrl + "polizze?risk=true",
        attestatoRischioAreaPubblica: "/attestato-di-rischio",
        attestatorischio: Constants.basicPrivateAreaUrl + "polizze/polizza?risk=true",
        possiamoaiutarti: "/servizio-clienti",
        soccorsoauto: "/soccorso-stradale",
        privacy: Constants.basicPrivateAreaUrl + "home",
        denunciasinistri: Constants.basicPrivateAreaUrl + "sinistri",
        denuncianuovosinistro: Constants.basicPrivateAreaUrl + "sinistri/scelta-targa",
        preaperturasinistro: Constants.basicPrivateAreaUrl + "sinistri/preapertura-sinistro",
        denunceinviate: Constants.basicPrivateAreaUrl + "sinistri/denunce-inviate",
        confermainviodenuncia: Constants.basicPrivateAreaUrl + "sinistri/conferma-invio-denuncia",
        inserimentopin: Constants.basicPrivateAreaUrl + "home/aggiornamento-profilo/pin",
        //informativaprivacy: '/TpdPortalCommons/build/assets/USA_Info_Hins_02.pdf',
        informativaprivacy: "/TpdPortalCommons/build/assets/USA_Info_UteU_01.pdf",
        informativaprivacyUnipol: "/NextAssets/pdf/USA_Info_UteU_01.pdf",
        informativaprivacyArAp: "/wcm/myconnect/35158955-0c4f-47e2-852f-9582f44f4715/USA_Info_ArAp_01.pdf?MOD=AJPERES&CVID=oUUAq7y&useDefaultText=0&useDefaultDesc=0",
        informativaprivacyArApUnipol: "/wcm/myconnect/35158955-0c4f-47e2-852f-9582f44f4715/Informativa+Area+Riservata.pdf?MOD=AJPERES&CVID=pdjLvDZ&useDefaultText=0&useDefaultDesc=0",
        documentidettagliopolizza: Constants.basicPrivateAreaUrl + "polizze/polizza#documenti",
        informativaareariservata: "/informativa-area-riservata",
        riepilogodenuncia: Constants.basicPrivateAreaUrl + "sinistri/riepilogo-denuncia",
        fea: "/fea-firma-elettronica",
        sceltaTarghePas: Constants.basicPrivateAreaUrl + "assistenza",
        noTargheAssistenza: Constants.basicPrivateAreaUrl + "no-assistenza",
        motivazione: Constants.basicPrivateAreaUrl + "assistenza/richiesta",
        questionario: Constants.basicPrivateAreaUrl + "assistenza/questionario",
        dettaglio: Constants.basicPrivateAreaUrl + "assistenza/dettaglio",
        preventivatoreFQ: "/preventivatore-auto",
        preventiviAuto: "/preventivatore-auto/step2-3-prev-auto",
        preventiviMoto: "/preventivatore-moto/step2-3-prev-moto",
        sanicard: Constants.basicPrivateAreaUrl + "polizze/polizza/sanicard",
        popcoin: Constants.basicPrivateAreaUrl + "popcoin",
        informativaPopcoin: Constants.basicPrivateAreaUrl + "popcoin/presentazione-iniziativa",
        iscrizione: Constants.basicPrivateAreaUrl + "popcoin/iscrizione",
        iscrizioneEsito: Constants.basicPrivateAreaUrl + "popcoin/iscrizione/esito",
        elencoBuoni: Constants.basicPrivateAreaUrl + "popcoin/elenco-buoni",
        elencoBuoniCancella: Constants.basicPrivateAreaUrl + "popcoin/elenco-buoni/cancella",
        estrattoConto: Constants.basicPrivateAreaUrl + "popcoin/estratto-conto",
        creaBuono: Constants.basicPrivateAreaUrl + "popcoin/crea-buono",
        creaBuonoEsito: Constants.basicPrivateAreaUrl + "popcoin/crea-buono/esito",
        faqPopcoin: Constants.basicPrivateAreaUrl + "popcoin/faq",
        privacypage: Constants.basicPrivateAreaUrl + "dati-personali/privacy",
        servizioClienti: "/servizio-clienti/informazioni",
        riepilogoVisita: Constants.basicPrivateAreaUrl +
            "sinistri/tracking-sinistri/riepilogo-visita",
        prenotazioneVisita: Constants.basicPrivateAreaUrl +
            "sinistri/tracking-sinistri/prenotazione-visita",
        modificaVersioneControparte: Constants.basicPrivateAreaUrl +
            "sinistri/modifica-versione-controparte",
        negaVersioneControparte: Constants.basicPrivateAreaUrl +
            "sinistri/tracking-sinistri/negazione-sinistro",
        caricamentoDocumenti: Constants.basicPrivateAreaUrl + "preventivi/acquista/documenti",
        spedizionePolizza: Constants.basicPrivateAreaUrl +
            "preventivi/acquista/spedizione-polizza",
        acquistoPolizza: Constants.basicPrivateAreaUrl + "preventivi/acquista",
        esitoAcquisto: Constants.basicPrivateAreaUrl + "preventivi/esito",
        esitoSpedizione: Constants.basicPrivateAreaUrl + "preventivi/esito-spedizione",
        sitointegratoagenzia: Constants.basicPrivateAreaUrl + "agenzia/ag/",
        aggiornamentoProfilo: Constants.basicPrivateAreaUrl + "home/aggiornamento-profilo",
        esitoAggiornamentoProfilo: Constants.basicPrivateAreaUrl + "home/aggiornamento-profilo/esito",
        notificheAreaRiservata: Constants.basicPrivateAreaUrl + "home/notifiche",
        informativaRinnovoPolizza: Constants.basicPrivateAreaUrl + "polizze/informativa-rinnovo-polizza",
        pagamentoInsoluto: Constants.basicPrivateAreaUrl + "polizze/pagamento-insoluto",
        terminiCondizioni: "/termini-condizioni-pagamento",
        trattamentoDatiPersonali: "/trattamento-dati-personali",
        pagamentoRinnovoPolizza: Constants.basicPrivateAreaUrl + "polizze/pagamento-rinnovo-polizza",
        esitoRinnovoPolizza: Constants.basicPrivateAreaUrl + "polizze/esito-rinnovo-polizza",
        telepedaggioLandingGuest: "telepedaggio-landing",
        telepedaggioLanding: Constants.basicPrivateAreaUrl + "telepedaggio-landing",
        telepedaggioAcquisto: Constants.basicPrivateAreaUrl + "telepedaggio-acquisto",
        serviziMobilita: Constants.basicPrivateAreaUrl + "servizi-mobilita",
        serviziMobilitaTelepedaggio: Constants.basicPrivateAreaUrl + "servizi-mobilita/telepedaggio",
        telepedaggioModificaOfferta: Constants.basicPrivateAreaUrl +
            "servizi-mobilita/telepedaggio/modifica-offerta",
        completamentoRegistrazione: Constants.basicPrivateAreaUrl + "completamento-registrazione",
        esitoAggiuntaCarta: Constants.basicPrivateAreaUrl + "esito-aggiunta-carta",
    },
];
Constants.creditRecharge = {
    base_url_prod: "https://ecommerce.nexi.it/ecomm/ecomm/DispatcherServlet",
    alias_prod: "payment_768324",
    secret_key_prod: "55L83KRT67vL1K1PNNF2xE6J07l5UtC0dgs2UgFL",
    base_url_coll: "https://coll-ecommerce.keyclient.it/ecomm/ecomm/DispatcherServlet",
    alias_coll: "3444153",
    secret_key_coll: "TLGHTOWIZXQPTIZRALWKG",
    base_url_svil: "https://coll-ecommerce.keyclient.it/ecomm/ecomm/DispatcherServlet",
    alias_svil: "3444153",
    secret_key_svil: "TLGHTOWIZXQPTIZRALWKG",
};
Constants.purchaseKey = "A12Gu63FdHdC8pal9018H2fertRBFER50077Lpdg0Lafyqchz82THB9311Q";
// tslint:disable: object-literal-key-quotes
Constants.documentType = {
    "0": "foto",
    "1": "cartaid",
    "2": "patente",
    "3": "codfisc",
    "4": "cai",
    "5": "testimone",
    "6": "verbale",
    "7": "generico",
};
// tslint:enable: object-literal-key-quotes
Constants.TIPI_SINISTRO = {
    "01lobauto": "Auto",
    "09lobCredCau": "Credito e Cauzioni",
    "04DlobdannoProp": "Patrimonio",
    "06lobpropieta": "Proprietà",
    "03lobramispecialistici": "Rami Specialistici",
    "02lobsalute": "Salute",
    "05lobtrasporti": "Trasporti",
    "08lobTurismo": "Turismo",
};
Constants.VOCI_DI_DANNO = {
    PropertyIncident: "",
    MobilePropertyIncident: "Danno a Cose Trasportate",
    VehicleIncident: "Danno al Veicolo",
    FixedPropertyIncident: "Danno a Cose",
    InjuryIncident: "Lesioni",
    BaggageIncident: "Danno al Bagaglio",
    DwellingIncident: "",
    Incident: "Danno al Veicolo",
    LivingExpensesIncident: "",
    OtherStructureIncident: "",
    PerditaPecuniariaIncident_Ext: "Perdite Patrimoniali",
    PropertyContentsIncident: "",
    TripIncident: "Danno in Viaggio",
};
Constants.TIPI_INCARICHI = {
    IncaricoAuto_Ext: "Perito Auto",
    IncaricoMedico_Ext: "Medico",
    IncaricoRe_Ext: "Perito",
    IncaricoCarrozzeria_Ext: "Carrozzeria",
    IncaricoCarrozzeriaHUB_Ext: "Servizi Unipol",
};
/* tslint:disable: object-literal-key-quotes */
Constants.NUMERI_ORDINALI = {
    "1": "Primo",
    "2": "Secondo",
    "3": "Terzo",
    "4": "Quarto",
    "5": "Quinto",
    "6": "Sesto",
    "7": "Settimo",
    "8": "Ottavo",
    "9": "Nono",
    "10": "Decimo",
    "11": "Undicesimo",
    "12": "Dodicesimo",
    "13": "Tredicesimo",
    "14": "Quattordicesimo",
    "15": "Quindicesimo",
    "16": "Sedicesimo",
    "17": "Diciassettesimo",
    "18": "Diciottesimo",
    "19": "Diciannovesimo",
    "20": "Ventesimo",
    "21": "Ventunesimo",
    "22": "Ventiduesimo",
    "23": "Ventitreesimo",
    "24": "Ventiquattresimo",
    "25": "Venticinquesimo",
    "26": "Ventiseiesimo",
    "27": "Ventisettesimo",
    "28": "Ventottesimo",
    "29": "Ventinovesimo",
    "30": "Trentesimo",
};
/* tslint:enable: object-literal-key-quotes */
Constants.SINISTRI_GESTITI = {
    "01lobauto": "RCA",
    "09lobCredCau": "",
    "04DlobdannoProp": "RE",
    "06lobpropieta": "RE",
    "03lobramispecialistici": "",
    "02lobsalute": "RE",
    "05lobtrasporti": "",
    "08lobTurismo": "",
};
Constants.VOCI_DI_DANNO_RE = {
    "04DlobdannoProp": "Danno a cose",
    "06lobpropieta": "Danno a cose",
    "02lobsalute": "Lesione",
};
/* tslint:disable: object-literal-key-quotes */
////////// MAPPE//////////////
Constants.statesMap = {
    "0": { message: "regolare con i pagamenti", color: "#629419" },
    "1": { message: "regolare entro i termini di mora", color: "#e1e351" },
    "2": { message: "non regolare, contatta il tuo agente", color: "#c35619" },
};
Constants.headersMap = {
    "1000": { text: "MOBILITÀ", icon: "icon-Mobilita", color: "blue-green" },
    "1001": { text: "CASA", icon: "icon-Casa", color: "green" },
    "1002": { text: "PROTEZIONE", icon: "icon-Protezione", color: "orange" },
    "1003": { text: "RISPARMIO", icon: "icon-Risparmio", color: "purple" },
    "1004": { text: "LAVORO", icon: "icon-Business", color: "yellow" },
    "1005": { text: "ALTRO", icon: "icon-Polizze", color: "soft_blue" },
};
// NUOVA GESTIONE PER CROMIE, TUTTI I COMPONENTI tpd-policy-tile useranno questi dati
Constants.tpdPolicyTilesHeaderStyles = {
    "1000": { text: "MOBILITÀ", icon: "icon-Mobilita", color: "blue" },
    "1001": { text: "CASA", icon: "icon-Casa2", color: "orange" },
    "1002": { text: "PROTEZIONE", icon: "icon-Protezione", color: "green" },
    "1003": { text: "RISPARMIO", icon: "icon-Risparmio", color: "green" },
    "1004": { text: "LAVORO", icon: "icon-Business", color: "orange" },
    "1005": { text: "ALTRO", icon: "icon-Polizze", color: "blue" },
    previdenza: { text: "PREVIDENZA", icon: "icon-Clessidra", color: "green" }, //HACK: non avendo un family id che identifica la previdenza
};
/* tslint:enable: object-literal-key-quotes */
Constants.garanzieMap = {
    netPremium: { text: "Premio Netto", value: null },
    notPayableMinimal: { text: "Minimo non rimborsabile", value: null },
    uncoveredPercentage: { text: "Percentuale Scoperto", value: null },
    exemption: { text: "Esenzione", value: null },
    rightWrongMaxCoverage: { text: "Massimale Torto / Ragione", value: null },
    healthExpenditureMaxCoverage: {
        text: "Massimale Spese Sanitarie",
        value: null,
    },
    permanentDisabilityMaxCoverage: {
        text: "Massimale Disabilità Permanente",
        value: null,
    },
    deathMaxCoverage: { text: "Massimale Morte", value: null },
    optionalValue: { text: "Valori Accessori", value: null },
    insuranceValue: { text: "Valore Assicurato", value: null },
    salesFormat: { text: "Nome", value: null },
    code: { text: "Codice", value: null },
};
Constants.encrypt = {
    encType: "1",
    encPipe: "|",
};
Constants.geolocationOptions = {
    enableHighAccuracy: true,
    timeout: 10000,
    maximumAge: 0,
};
Constants.geolocationRestriction = "IT";
Constants.uniboxLabels = {
    AUTO: "UNIBOX",
    CANE_GATTO: "UNIBOX CANE & GATTO",
    CASA_COMMERCIO: "UNIBOX CASA & COMMERCIO",
    CASA: "UNIBOX CASA",
    COMMERCIO: "UNIBOX LAVORO",
    IMPRESA_SERVIZI: "UNIBOX LAVORO",
    CONDOMINIO_SERVIZI: "UNIBOX CONDOMINIO & SERVIZI",
    ALBERGO_SERVIZI: "UNIBOX ALBERGO & SERVIZI",
    UNIBOX_TAG: "TECNOLOGIA",
};
Constants.cpmStatus = {
    NON_PRENOTABILE: "Non prenotabile",
    PRENOTABILE: "Prenotabile",
    MODIFICABILE: "Modificabile",
    RIPRENOTABILE: "Riprenotabile",
};
Constants.cardPassivi = {
    CLAIM_STATE: "Da verificare",
    ACTION_STATE: "Da verificare",
    ACTION_TYPE: "riscontraSinistro",
    CONFIRM_PASSIVE_CLAIM: "Conferma",
    MODIFY_PASSIVE_CLAIM: "Modifica",
    DENY_PASSIVE_CLAIM: "Negazione",
};
Constants.assignmentStatus = {
    INCARICATO: "incaricato",
    RESTITUITO: "restituito",
};
Constants.labels = {
    commons: {
        ATTENZIONE: "Attenzione",
        TORNA_INDIETRO: "Torna indietro",
        RICARICA_UPPERCASE: "RICARICA",
        ERRORE: "Si è verificato un errore. Si prega di riprovare più tardi.",
        PROBLEMA_RECUPERO_DATI: "Si è verificato un problema durante il recupero dei dati. Si prega di riprovare più tardi",
        TORNA_AI_TUOI_RISULTATI: "Torna ai tuoi risultati",
        CHIAMA_AGENZIA: "Chiama la tua agenzia",
    },
};
Constants.riepilogoVisitaLabels = {
    ANNULLA_VISITA: "Annulla visita",
    // tslint:disable-next-line: quotemark
    LINK_NON_VALIDO: "Il link che hai utilizzato non è valido. Si prega di ricontrollare l\\'indirizzo o contattare la propria agenzia.",
    IMPOSSIBILE_RECUPERARE_INFO_VISITA: "Non è stato possibile recuperare le informazioni della visita. Si prega di contattare la propria agenzia.",
    VISITA_NON_MODIFICABILE: "Non è più possibile modificare la visita poiché mancano meno di 48 ore alla visita stessa.<br>Ti invitiamo a contattare la tua agenzia.",
    VISITA_NON_MODIFICABILE_MESSAGGIO_GENERICO: "Su questo sinistro non sono presenti visite modificabili.",
    ERRORE_ELIMINAZIONE_VISITA: "Stiamo elaborando la tua richiesta di prenotazione della visita ed al momento non è possibile annullarla. Riprova tra qualche minuto, se il problema persiste contatta la tua agenzia",
    ERRORE_GENERICO: "Impossibile annullare la visita. Contatta la tua agenzia",
};
Constants.prenotazioneVisitaLabels = {
    // tslint:disable: quotemark
    CLINICA_NON_DISPONIBILE: "La clinica selezionata non è disponibile per l'utente",
    CLINICA_NON_HA_DATE_DISPONIBILI: "La clinica selezionata non ha date prenotabili a disposizione. Selezionare un'altra clinica oppure annullare la visita",
    ORARIO_GIA_UTILIZZATO: "L'orario selezionato è già impegnato. Effettua una nuova scelta",
    // tslint:enable: quotemark
    ERRORE_PRENOTAZIONE_VISITA: "Si è verificato un problema durante la prenotazione della visita. Riprovare",
};
// tslint:disable: object-literal-key-quotes
Constants.stepMap = {
    "0": "assegnato",
    "1": "incarico",
    "2": "valutazione",
    "3": "liquidazione",
    "4": "chiuso",
};
// tslint:enable: object-literal-key-quotes
Constants.typeValue = {
    PropertyIncident: "",
    MobilePropertyIncident: "Danno a Cose Trasportate",
    VehicleIncident: "Danno al Veicolo",
    FixedPropertyIncident: "Danno a Cose",
    InjuryIncident: "Lesioni",
    BaggageIncident: "",
    DwellingIncident: "",
    Incident: "Danno al Veicolo",
    LivingExpensesIncident: "",
    OtherStructureIncident: "",
    PerditaPecuniariaIncident_Ext: "Perdite Patrimoniali",
    PropertyContentsIncident: "",
    TripIncident: "Danno in Viaggio",
    DenunciaDellaControparte: "Denuncia della controparte",
};
Constants.codiciTariffaPolizzeVita = [
    "TU90000UL",
    "TU90000UL1",
    "TU90000UL1C",
    "TU90000UL1C",
    "TU90000UL1K",
    "TU90000UL1R",
    "TU90000UL2",
    "TU90000UL2C",
    "TU90000UL2K",
    "TU90000UL2R",
    "TU90000ULC",
    "TU90000ULK",
    "TU90000ULR",
    "TU90001UL",
    "TU90001UL1",
    "TU90001UL1C",
    "TU90001UL1K",
    "TU90001UL2",
    "TU90001UL2C",
    "TU90001UL2K",
    "TU90001ULC",
    "TU90001ULK",
];
Constants.SIA = {
    COOKIE_CODE: "VW5pcG9sC",
    COOKIE_PATH: "VW5pcG9s",
    LOCAL_STORAGE: "_data9",
    LOCAL_STORAGE_TMP: "agency_tmp",
    NO_SIA_CODE: "0",
    NO_SIA_MESSAGE: "No Sia Agency",
};
Constants.NOTIFICHE = {
    TOPICS: {
        NOTIFICHE_COMMERCIALI: "121",
    },
};
Constants.acquistoPreventiviDocumenti = {
    azioniAcquisto: {
        INTEGRA: "INTEGRA_DOCUMENTI",
        ACQUISTA: "ACQUISTA",
        NESSUNA: "NESSUNA_AZIONE",
    },
    statoDocumenti: {
        CARICATO: ["CARICATO", "In approvazione"],
        INVALIDO: ["INVALIDO", "Non riconosciuta"],
        VALIDO: ["VALIDO", "Approvato"],
        ASSENTE: ["ASSENTE", "Da caricare"],
        FORZATO: ["FORZATO", "Approvato"],
        DEROGATO: [
            "DEROGATO",
            "Da fornire entro 30 giorni dalla data di emissione della polizza",
        ],
    },
    labelDocumenti: {
        tipoDocumento: {
            CARTA_IDENTITA_CONTRAENTE: [
                "CI_CONTRAENTE",
                "CARTA DI IDENTITÀ",
                "LA TUA CARTA DI IDENTITÀ",
            ],
            CARTA_IDENTITA_PROPRIETARIO: [
                "CI_PROPRIETARIO",
                "CARTA DI IDENTITÀ",
                "LA CARTA DI IDENTITÀ DEL PROPRIETARIO",
            ],
            DIRITTO_CONVENZIONE: ["DIRITTO_CONVENZIONE", "DIRITTO CONVENZIONE"],
            STATO_FAMIGLIA: ["STATO_FAMIGLIA", "STATO DI FAMIGLIA"],
            LIBRETTO: ["LIBRETTO", "LIBRETTO"],
            DEFAULT: ["ALTRO DOCUMENTO"],
        },
    },
};
Constants.acquistoPreventiviTipoUniboxMap = {
    ASSENTE: "ASSENTE",
    SUPEREASY: "SUPEREASY",
    FULL: "FULL",
    BLACKBOX: "BLACKBOX",
    VOICE: "VOICE",
    SMART_DRIVE: "SMART DRIVE",
    SMART_DRIVE_CON_BODYGUARD: "SMART DRIVE CON BODYGUARD",
};
Constants.acquistoPreventiviStatiMap = [
    {
        code: "IT",
        nome: "ITALIA",
        cap: "",
    },
    {
        code: "SM",
        nome: "REPUBBLICA DI SAN MARINO",
        cap: "",
    },
    {
        code: "VA",
        nome: "CITTA' DEL VATICANO",
        cap: "00120",
    },
];
Constants.ttlSessionStorage = 900000; //15 minuti usato in prod
Constants.shortTtlSessionStorage = 900000; //15 minuti usato in inte svil e coll
Constants.networkConfigSessionStorageParameter = "_nC";
Constants.sl = "_sL";
Constants.uniqueElencoNotifiche = "_eNot";
Constants.myReportsResponse = "_mYRep";
Constants.sentAnalyticsRenewal = "_sentAnalyticsRenewal";
Constants.fasceOrarieRicontatto = {
    prima: "8-12",
    seconda: "12-14",
    terza: "14-19",
};
Constants.funnelNamesReg41 = {
    FUNNEL_NAME_SOSPENDI_RIATTIVA: "sospendi riattiva polizza",
    FUNNEL_NAME_MODIFICA_DATI_PERSONALI: "modifica dati personali",
    FUNNEL_NAME_RICHIESTA_VERSAMENTI_AGGIUNTIVI: "richiedi versamento aggiuntivo",
    FUNNEL_NAME_RICHIEDI_RISCATTO: "richiedi riscatto",
    FUNNEL_NAME_RICHIEDI_INFO: "richiedi info sulle condizioni di rinnovo",
    FUNNEL_NAME_RICHIEDI_INFO_AGENZIA: "richiedi info in agenzia",
    FUNNEL_NAME_RICHIEDI_CONTATTO_AGENTE: "richiedi al tuo agente di contattarti",
};
Constants.coloriCromie = {
    blue: {
        primary: "#0169B4",
        secondary: "#00AFCB",
        background: "#E8F5FF",
    },
    green: {
        primary: "#59A627",
        secondary: "#88B817",
        background: "#F5FAED",
    },
    orange: {
        primary: "#E94E10",
        secondary: "#F39200",
        background: "#FDF5F2",
    },
};
Constants.NOTIFICATION_COUNT_UPDATE = "NOTIFICATION_COUNT_UPDATE";
Constants.NOTIFICATION_RESPONSE = "NOTIFICATION_RESPONSE";
Constants.SERVICE_LEVEL = "SERVICE_LEVEL";
Constants.LOYALTY_RESPONSE = "LOYALTY_RESPONSE";
Constants.CONFIGURATORI = {
    commercio: "preventivatore_commercio",
    casa: "preventivatore_casa",
    impresa: "preventivatore_impresa",
    condominio: "preventivatore_condominio",
    pet: "preventivatore_animali",
    infortuni: "preventivatore_infortuni",
    salute: "preventivatore_salute",
};
Constants.ENUM_ID_PACCHETTI = {
    ABBONAMENTO: "abbonamento",
    PPU: "PayPerUse",
};
Constants.ENUM_ID_TIPO_PACCHETTO = {
    CANONE: "canone",
};
